import {MolecularGraph} from "../../graph/MolecularGraph"
import {extractorUtil} from "../../util/extractorUtil";
import {Feature, Features} from "../../feature";

export const nitrileExtractor = {
    extract: (graph: MolecularGraph) => {
        const features : Feature[] = [];
        const roots = extractorUtil.getFunctionalGroupRootsWithElement("C", graph);
        roots.forEach(carbon => {
            const bonds = graph.getBondsAttachedTo(carbon);
            const nitrileBonds = bonds.filter(b => b.getOtherAtom(carbon).symbol === "N" && b.order === 3);
            if(nitrileBonds.length > 0) {
                const nitrogen = nitrileBonds[0].getOtherAtom(carbon);
                if(nitrogen.lonePairs === 1 && nitrogen.charge === 0) {
                    features.push({name: Features.nitrile, atoms:[carbon, nitrogen], connections:[carbon]})
                }
            }
        })

        return features;
    }
}
